export interface LNavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: LNavigationRoute[]
}

const filterRoutesByRole = (routes: LNavigationRoute[], role: string): LNavigationRoute[] => {
  return routes
    .filter((route) => {
      // Check if the route has allowed roles, and if the user's role is allowed
      if (route.meta.allowedRoles && route.meta.allowedRoles.includes(role)) {
        return true // Accessible by the user's role
      }
      // Fallback condition for routes without role restrictions (e.g., dashboard)
      if (!route.meta.allowedRoles) {
        return true // Accessible by everyone
      }
      return false // Hide route if not allowed for the user's role
    })
    .map((route) => {
      // Recursively filter children routes if any
      if (route.children) {
        route.children = filterRoutesByRole(route.children, role)
      }
      return route
    })
}

const sidebarRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'Dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
        allowedRoles: ['admin', 'operator'],
      },
      children: [
        // { name: 'monitor', displayName: 'Monitor', meta: { icon: 'monitor-icon', allowedRoles: ['admin'] } },
        {
          name: 'performance',
          displayName: 'Driver Performance Dashboard',
          meta: { icon: 'monthly-dashboard-icon', allowedRoles: ['admin', 'operator'] },
        },
        //  { name: 'vehicleperformance', displayName: 'Vehicle Performance Dashboard', meta: { icon: 'monthly-dashboard-icon', allowedRoles: ['admin','operator'] } },
        // { name: 'today', displayName: 'Compare', meta: { icon: 'compare-icon', allowedRoles: ['operator'] } },
        // { name: 'dashboard', displayName: 'Monthly Dashboard', meta: { icon: 'monthly-dashboard-icon', allowedRoles: ['admin'] } },
        // { name: 'scorecard', displayName: 'Scorecard', meta: { icon: 'scorecard-icon', allowedRoles: ['admin'] } },
      ],
    },

    // {
    //   name: 'operators',
    //   displayName: 'Operators',
    //   meta: { icon: 'support_agent', allowedRoles: ['admin'] },
    // },
    {
      name: 'drivers',
      displayName: 'Drivers',
      meta: { icon: 'moped', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'our-drivers',
      displayName: 'Our Drivers',
      meta: { icon: 'person', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'issues',
      displayName: 'Tickets',
      meta: { icon: 'dataset', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'fleet-vehicles-menu',
      displayName: 'Vehicles',
      meta: { icon: 'commute', allowedRoles: ['admin', 'operator'] },
      children: [
        {
          name: 'vehicles',
          displayName: 'Uber Vehicles',
          meta: { icon: 'commute', allowedRoles: ['admin', 'operator'] },
        },
        {
          name: 'our-vehicles',
          displayName: 'Our Vehicles',
          meta: { icon: 'directions_car', allowedRoles: ['admin', 'operator'] },
        },
        {
          name: 'bikes',
          displayName: 'Bikes',
          meta: { icon: 'two_wheeler', allowedRoles: ['admin', 'operator'] },
        },
      ],
    },
    {
      name: 'trips',
      displayName: 'Trips',
      meta: { icon: 'folder_shared', allowedRoles: ['admin', 'operator'] },
    },
    // {
    //   name: 'payments',
    //   displayName: 'Maintenance',
    //   meta: { icon: 'engineering', allowedRoles: ['admin'] },
    //   children: [
    //     { name: 'maintenance', displayName: 'List', meta: { icon: 'list-icon', allowedRoles: ['admin'] } },
    //      { name: 'maintenance-items', displayName: 'Items', meta: { icon: 'list-icon', allowedRoles: ['admin'] } },
    //         { name: 'maintenance-workshops', displayName: 'Workshops', meta: { icon: 'list-icon', allowedRoles: ['admin'] } }
    //   ],
    // },
    {
      name: 'messages',
      displayName: 'Messages',
      meta: { icon: 'message', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'driver-training',
      displayName: 'Driver Training',
      meta: { icon: 'school', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'reports',
      displayName: 'Reports',
      meta: { icon: 'today', allowedRoles: ['admin', 'operator'] },
      children: [
        {
          name: 'reports',
          displayName: 'All Reports',
          meta: {
            icon: 'assessment',
            allowedRoles: ['admin', 'operator'],
          },
        },
        {
          name: 'odometer-reports',
          displayName: 'Odometer Reports',
          meta: {
            icon: 'speed',
            allowedRoles: ['admin', 'operator'],
          },
        },
        {
          name: 'charging-reports',
          displayName: 'Charging Reports',
          meta: {
            icon: 'battery_charging_full',
            allowedRoles: ['admin', 'operator'],
          },
        },
      ],
    },
    {
      name: 'analytics',
      displayName: 'Analytics',
      meta: { icon: 'analytics', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'teams',
      displayName: 'Teams',
      meta: { icon: 'folder', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'tickets',
      displayName: 'Tickets',
      meta: { icon: 'assignment', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'violations-escalation',
      displayName: 'Violations Escalation',
      meta: { icon: 'gpp_maybe', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'maintenance',
      displayName: 'Maintenance',
      meta: { icon: 'engineering', allowedRoles: ['admin', 'operator'] },
      children: [
        {
          name: 'maintenance',
          displayName: 'Maintenance List',
          meta: { icon: 'list', allowedRoles: ['admin', 'operator'] },
        },
        {
          name: 'maintenance-items',
          displayName: 'Maintenance Items',
          meta: { icon: 'inventory', allowedRoles: ['admin', 'operator'] },
        },
        {
          name: 'maintenance-workshops',
          displayName: 'Workshops',
          meta: { icon: 'business', allowedRoles: ['admin', 'operator'] },
        },
      ],
    },
    {
      name: 'ev-dashboard',
      displayName: 'EV Dashboard',
      meta: { icon: 'electric_car', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'alarms',
      displayName: 'Alarms',
      meta: { icon: 'notifications', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'compare',
      displayName: 'Compare',
      meta: { icon: 'compare_arrows', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'issues',
      displayName: 'Issues',
      meta: { icon: 'warning', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'preferences',
      displayName: 'Profile',
      meta: { icon: 'manage_accounts', allowedRoles: ['admin', 'operator'] },
    },
    // {
    //   name: 'settings',
    //   displayName: 'Settings',
    //   meta: { icon: 'settings', allowedRoles: ['admin', 'operator'] },
    // },
  ],
}

export default sidebarRoutes
